module.exports = __webpack_public_path__ + "img/Computers.f0223ea6.png";